import type { TagRemovedEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const TagRemovedEvent = memo(function TagRemovedEvent({
  event,
  data,
}: {
  event: ConversationTimelineEventResponse;
  data: TagRemovedEventData;
}) {
  return (
    <Flex align="flex-start" className={styles.card} gap="sm">
      <Flex
        align="center"
        className={`${styles.icon} ${styles.iconGrayBlue}`}
        justify="center"
      >
        <TagIcon />
      </Flex>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Tag &quot;{data.tagName}&quot; removed
        </Text>
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
